export const KYC = '/kyc';
export const resellerForm = '/kyc/reseller';
export const createCompany = '/createCompany';

export default {
    createCompany,
    KYC,
    resellerForm,
};
